<template>
    <v-form ref="etapeIdentification" id="etapeIdentification" v-model="$storeCandidature.etapeIentificationValide" lazy-validation>
        <v-container grid-list-md text-xs-center>
            <v-layout row wrap xs12>
                <Comp_Identite v-on:Valide="ValidateForm()" v-if="etape == 1"></Comp_Identite>
            </v-layout>
            <v-layout row wrap xs12>
                <v-flex xs4 v-if="etape == 1">
                    <Comp_Email></Comp_Email>
                </v-flex>
                <v-flex xs4 v-if="etape == 1">
                    <Comp_Telephone :telephone=$storeCandidature.sasCandidature.Identification.Telephone></Comp_Telephone>
                </v-flex>
            </v-layout>
            <v-layout row wrap xs12>
                <v-flex xs4 text-xs-left>
                    <vc-date-picker v-model="$storeCandidature.sasCandidature.Identification.DateNaissance"
                                    update-on-input @input="dateSelected">
                        <template v-slot="{ inputValue, inputEvents }">
                            <v-text-field :label="$storeCandidature.langueFormulaire == 'en' ? 'Date of Birth' : 'Date de naissance'"
                                          :value="inputValue"
                                          v-model="$storeCandidature.sasCandidature.Identification.DateNissanceSaisie"
                                          v-on="inputEvents"
                                          placeholder="DD/MM/YYYY"
                                          @keyup="dateSaisieChange"
                                          @change="dateSaisieValidate"
                                          prepend-inner-icon="calendar_today"
                                          :rules="[$rules.dateInferieurDe($storeCandidature.sasCandidature.Identification.DateNaissance, 5, $storeCandidature.langueFormulaire),$rules.required($storeCandidature.langueFormulaire)]" />
                        </template>
                    </vc-date-picker>
                </v-flex>
                <v-flex xs8>
                    <v-autocomplete class="pt-1" :menu-props="{maxHeight:'40%'}"
                                    :label="$storeCandidature.langueFormulaire == 'en' ? 'Country of Citizenship' : 'Nationalité'"
                                    :items="$storeCandidature.configurationClient.PaysList"
                                    v-model="$storeCandidature.sasCandidature.Identification.Nationalite"
                                    :item-text="$storeCandidature.langueFormulaire == 'en' ? 'Lang01' : 'Lang00'"
                                    item-value="Id"
                                    return-object
                                    :rules="[$rules.required($storeCandidature.langueFormulaire)]"
                                    @change="$storeCandidature.candidatureChanged = true">
                        <!-- chips -->
                        <template v-slot:selection="data">
                            <v-chip class="v-chip--select-multi info" dark
                                    @click.stop="data.parent.selectedIndex = data.index">{{data.item.Lang00}}</v-chip>
                        </template>
                    </v-autocomplete>
                </v-flex>
            </v-layout>
            <v-layout row wrap xs12>
                <v-flex xs4 v-if="$storeCandidature.sasCandidature.Ecole
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInseecBachelors
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdBtsInseec
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInternational
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInseecBba">
                    <v-autocomplete class="pt-0" :items="$storeCandidature.configurationClient.PaysList"
                                    v-model="$storeCandidature.sasCandidature.Identification.PaysNaissance"
                                    :label="$storeCandidature.langueFormulaire == 'en' ? 'Country of birth' : 'Pays de naissance'"
                                    :item-text="$storeCandidature.langueFormulaire == 'en' ? 'Lang01' : 'Lang00'"
                                    item-value="Id"
                                    return-object
                                    chips
                                    deletable-chips
                                    @change="$storeCandidature.candidatureChanged = true">
                    </v-autocomplete>
                </v-flex>
                <v-flex xs4 v-if="$storeCandidature.configurationClient
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleSupDePub
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInseecBba
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIdSupCreation
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInseecMscMba
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInseecBachelors
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdBtsInseec
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInternational
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIum
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIdDBA
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIdPHD
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleHeip
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIdSupCreation
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIdCeds
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleEce
                        && $storeCandidature.dataIdFormulaireCandidature != $storeCandidature.configurationClient.DescIdFormulaireBachelorsEsce
                        && $storeCandidature.dataIdFormulaireCandidature != $storeCandidature.configurationClient.DescIdFormulaireDBA
                        && $storeCandidature.dataIdFormulaireCandidature != $storeCandidature.configurationClient.DescIdFormulairePHD
                        && ($storeCandidature.dataIdFormulaireCandidature != $storeCandidature.configurationClient.DescIdFormulaireMscEsce)
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIsbe">
                    <v-text-field :counter="30"
                                  v-model="$storeCandidature.sasCandidature.Identification.DepartNaissance"
                                  :label="$storeCandidature.langueFormulaire == 'en' ? 'Country of birth' : 'Département de naissance'"
                                  @change="$storeCandidature.candidatureChanged = true">
                    </v-text-field>
                </v-flex>
                <v-flex xs4 v-if="$storeCandidature.configurationClient
                        && $storeCandidature.dataIdFormulaireCandidature != $storeCandidature.configurationClient.DescIdFormulaireMscEsce
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleHeip
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInseecBachelors
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdBtsInseec
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIdSupCreation
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIsbe
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleSupDePub
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleEce
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInseecBba
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIdCeds">
                    <v-text-field :counter="30"
                                  v-model="$storeCandidature.sasCandidature.Identification.VilleNaissance"
                                  :label="$storeCandidature.langueFormulaire == 'en' ? 'City of birth': 'Ville de naissance'"
                                  @change="$storeCandidature.candidatureChanged = true">
                    </v-text-field>
                </v-flex>
                <!--</v-layout>
                <v-layout row wrap xs12>-->
                <v-flex xs4 v-if="$storeCandidature.configurationClient
                        && $storeCandidature.dataIdFormulaireCandidature != $storeCandidature.configurationClient.DescIdFormulaireBachelorsEsce
                        && $storeCandidature.dataIdFormulaireCandidature != $storeCandidature.configurationClient.DescIdFormulaireEsceInternationaleId
                        && ($storeCandidature.dataIdFormulaireCandidature != $storeCandidature.configurationClient.DescIdFormulaireMscEsce)
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIdDBA
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIdPHD
                        && $storeCandidature.dataIdFormulaireCandidature != $storeCandidature.configurationClient.DescIdFormulairePHD
                        && $storeCandidature.dataIdFormulaireCandidature != $storeCandidature.configurationClient.DescIdFormulaireDBA
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleHeip
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIdCeds
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIdSupCreation
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIsbe
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleEce
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleSupDePub
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInseecBba">
                    <v-text-field :counter="100"
                                  v-model="$storeCandidature.sasCandidature.Identification.Rue1"
                                  :label="$storeCandidature.langueFormulaire == 'en' ? 'Address' : 'Adresse'"
                                  @change="$storeCandidature.candidatureChanged = true">
                    </v-text-field>
                </v-flex>
                <v-flex xs4 v-if="$storeCandidature.sasCandidature.Ecole && $storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleIum">
                    <v-text-field :counter="100"
                                  v-model="$storeCandidature.sasCandidature.Identification.Rue2"
                                  :label="$storeCandidature.langueFormulaire == 'en' ? 'Address line 2' : 'Adresse ligne 2'"
                                  @change="$storeCandidature.candidatureChanged = true">
                    </v-text-field>
                </v-flex>
                <v-flex xs4 v-if="$storeCandidature.configurationClient
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleEce
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIdSupCreation
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInternational
                        && $storeCandidature.dataIdFormulaireCandidature != $storeCandidature.configurationClient.DescIdFormulaireEsceInternationaleId
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIsbe
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleSupDePub&& $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleHeip
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIdCeds
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInseecBba">
                    <v-text-field :counter="10"
                                  v-model="$storeCandidature.sasCandidature.Identification.CP"
                                  :label="$storeCandidature.langueFormulaire == 'en' ? 'Postcode' : 'CP de résidence'"
                                  @change="$storeCandidature.candidatureChanged = true">
                    </v-text-field>
                </v-flex>
                <v-flex v-if="$storeCandidature.configurationClient
                        && $storeCandidature.dataIdFormulaireCandidature != $storeCandidature.configurationClient.DescIdFormulaireEsceInternationaleId
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIdSupCreation
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIsbe
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleSupDePub
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleEce
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleHeip
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIdCeds
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInseecBba" xs4>
                    <v-text-field :counter="30"
                                  v-model="$storeCandidature.sasCandidature.Identification.Ville"
                                  :label="$storeCandidature.langueFormulaire == 'en' ? 'City' : 'Ville de résidence'"
                                  @change="$storeCandidature.candidatureChanged = true">
                    </v-text-field>
                </v-flex>
                <v-flex xs4 v-if="$storeCandidature.sasCandidature.Ecole && $storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleIum">
                    <v-text-field :counter="30"
                                  v-model="$storeCandidature.sasCandidature.Identification.RegionEtat"
                                  :label="$storeCandidature.langueFormulaire == 'en' ? 'State / Province / Region' : 'Regin / Etat'"
                                  @change="$storeCandidature.candidatureChanged = true">
                    </v-text-field>
                </v-flex>
                <v-flex xs4>
                    <v-autocomplete class="pt-0" :items="$storeCandidature.configurationClient.PaysList"
                                    :label="$storeCandidature.langueFormulaire == 'en' ? 'Country of residence' : 'Pays de résidence'"
                                    v-model="$storeCandidature.sasCandidature.Identification.Pays"
                                    :item-text="$storeCandidature.langueFormulaire == 'en' ? 'Lang01' : 'Lang00'"
                                    item-value="Id"
                                    return-object
                                    chips
                                    deletable-chips
                                    :rules="[$rules.required($storeCandidature.langueFormulaire)]"
                                    @change="$storeCandidature.candidatureChanged = true">
                    </v-autocomplete>
                </v-flex>
                <v-flex xs4 v-if="$storeCandidature
                        && $storeCandidature.dataIdFormulaireCandidature == $storeCandidature.configurationClient.DescIdFormulaireBachelorsEsce">
                    <v-autocomplete class="pt-0" :items="$storeCandidature.configurationClient.Lv2List"
                                    :label="$storeCandidature.langueFormulaire == 'en' ? 'LV2' : 'LV2'"
                                    v-model="$storeCandidature.sasCandidature.Identification.LV2"
                                    :item-text="$storeCandidature.langueFormulaire == 'en' ? 'Lang01' : 'Lang00'"
                                    item-value="Id"
                                    return-object
                                    chips
                                    deletable-chips
                                    @change="$storeCandidature.candidatureChanged = true">
                    </v-autocomplete>
                </v-flex>
                <v-flex xs4 v-if="$storeCandidature.sasCandidature.Ecole
                          &&  ($storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleInseecMscMba) ">
                    <v-text-field v-model="$storeCandidature.sasCandidature.Identification.EtablissementActuel"
                                  :label="$storeCandidature.langueFormulaire == 'en' ? 'Etablissement Actuel' : 'Etablissement Actuel'"
                                  @change="$storeCandidature.candidatureChanged = true">
                    </v-text-field>
                </v-flex>
                <v-flex xs4 v-if="($storeCandidature.sasCandidature.Ecole
                        && $storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleSupCareer)
                        && !verificationNationalite()">
                    <v-text-field :label="$storeCandidature.langueFormulaire == 'en' ? '' : 'Titre de séjour '"
                                  v-model="$storeCandidature.sasCandidature.Identification.TitreDeSejour"
                                  @change="$storeCandidature.candidatureChanged = true"
                                  placeholder=" ">
                    </v-text-field>
                </v-flex>
                <v-flex xs4 v-if="$storeCandidature.sasCandidature.Ecole &&
                        ($storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleIum)">
                    <span v-if="$storeCandidature.langueFormulaire == 'en' ">  If you don’t have a Skype account please indicate another social media or enter “N/A”  </span>
                    <v-text-field :counter="30"
                                  v-model="$storeCandidature.sasCandidature.Identification.SkypeId"
                                  :label="$storeCandidature.langueFormulaire == 'en' ? 'Skype ID' : 'Pseudo Skype'"
                                  @change="$storeCandidature.candidatureChanged = true">
                    </v-text-field>
                </v-flex>
                <v-flex xs4 v-if="$storeCandidature.dataIdFormulaireCandidature == $storeCandidature.configurationClient.DescIdFormulaireEbsRentreeDecaleeId   ">
                    <v-text-field :counter="30"
                                  v-model="$storeCandidature.sasCandidature.Identification.IdParcoursup"
                                  label="ID Parcoursup"
                                  @change="$storeCandidature.candidatureChanged = true">
                    </v-text-field>
                </v-flex>
            </v-layout>
            <v-layout row wrap xs12 v-if="!$storeCandidature.configurationClient.Loaded || ($storeCandidature.sasCandidature.Ecole &&
                     (($storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleInseecBachelors
                      || $storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdBtsInseec)
                      && $storeCandidature.sasCandidature.ChoixProgramme.NiveauAdmission
                      && $storeCandidature.sasCandidature.ChoixProgramme.NiveauAdmission.Id == $storeCandidature.configurationClient.DataIdNiveauAdmission1erAnnee)
                      || $storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleSupDePub)">
                <v-flex xs4 v-if="$storeCandidature.sasCandidature.Ecole
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleSupDePub">
                    <v-text-field ref="emailParent" name="emailParents" id="emailParent"
                                  :counter="50"
                                  prepend-icon="email"
                                  v-model="$storeCandidature.sasCandidature.Identification.CourrielParents"
                                  label="Email parents"
                                  :rules="[$rules.email($storeCandidature.langueFormulaire),
                                    $rules.differentFrom($storeCandidature.sasCandidature.Identification.Email, 'Email', $storeCandidature.langueFormulaire)]"
                                  @change="$storeCandidature.candidatureChanged = true">
                    </v-text-field>
                </v-flex>
                <v-flex xs4>
                    <v-text-field :counter="14"
                                  prepend-icon="phone"
                                  v-model="$storeCandidature.sasCandidature.Identification.TelParents"
                                  :label="$storeCandidature.langueFormulaire == 'en' ? 'Parents phone' : 'Téléphone parents'"
                                  :rules="[$rules.telephone($storeCandidature.langueFormulaire),
                                    $rules.differentFrom($storeCandidature.sasCandidature.Identification.Telephone, $storeCandidature.langueFormulaire == 'en' ? 'Phone' : 'Téléphone', $storeCandidature.langueFormulaire)]"
                                  title="Exemple : +33612345678, +33 612345678, 0033612345678, 0612345678"
                                  @change="$storeCandidature.candidatureChanged = true">
                    </v-text-field>
                </v-flex>
            </v-layout>
            <v-layout row wrap xs12>
                <v-flex xs4 v-if="!$storeCandidature.configurationClient.Loaded || ($storeCandidature.sasCandidature.Ecole
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInternational)">
                    <v-autocomplete class="pt-0" :items="$storeCandidature.configurationClient.ParamFormulaire.NiveauEtudes"
                                    v-model="$storeCandidature.sasCandidature.Identification.NiveauEtudes"
                                    :label="$storeCandidature.langueFormulaire == 'en' ? 'Current level of studies' : 'Niveau d\'études actuel'"
                                    :item-text="$storeCandidature.langueFormulaire == 'en' ? 'Lang01' : 'Lang00'"
                                    item-value="Id"
                                    :rules="[$rules.required($storeCandidature.langueFormulaire)]"
                                    v-on:change="niveauEtudeChanged()"
                                    return-object
                                    chips
                                    deletable-chips>
                    </v-autocomplete>
                </v-flex>
                <v-flex xs4 v-if="$storeCandidature.sasCandidature.Ecole
                        && $storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleIum ">
                    <v-text-field v-model="$storeCandidature.sasCandidature.Identification.PrecisionNiveau"
                                  :label="$storeCandidature.langueFormulaire == 'en' ? 'Current type of studies' : 'Niveau d\'études actuel'"
                                  :placeholder="$storeCandidature.langueFormulaire == 'en' ? 'Please specify (e.g. economics, psychology, etc.)' : 'Niveau d\'études actuel'"
                                  @change="$storeCandidature.candidatureChanged = true">
                    </v-text-field>
                </v-flex>
                <v-flex xs4 v-if="!$storeCandidature.configurationClient.Loaded || ($storeCandidature.configurationClient
                        && $storeCandidature.dataIdFormulaireCandidature != $storeCandidature.configurationClient.DescIdFormulaireBachelorsEsce
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIum
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInternational
                        && $storeCandidature.dataIdFormulaireCandidature != $storeCandidature.configurationClient.DescIdFormulaireEsceInternationaleId
                        && ($storeCandidature.dataIdFormulaireCandidature != $storeCandidature.configurationClient.DescIdFormulaireMscEsce))">
                    <v-autocomplete class="pt-0" :items="listeTypesEtude"
                                    v-model="$storeCandidature.sasCandidature.Identification.TypeEtudes"
                                    :label="$storeCandidature.langueFormulaire == 'en' ? 'Current type of studies' : 'Type d\'études'"
                                    :item-text="$storeCandidature.langueFormulaire == 'en' ? 'Lang01' : 'Lang00'"
                                    item-value="Id"
                                    :rules="[$rules.required($storeCandidature.langueFormulaire)]"
                                    @change="typeEtudesChanged()"
                                    return-object
                                    chips
                                    deletable-chips>
                    </v-autocomplete>
                </v-flex>
                <v-flex xs4 v-if="!$storeCandidature.configurationClient.Loaded || ($storeCandidature.configurationClient
                        && $storeCandidature.dataIdFormulaireCandidature != $storeCandidature.configurationClient.DescIdFormulaireBachelorsEsce
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIum
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInseecBachelors
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdBtsInseec
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInseecBba
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInternational
                        && $storeCandidature.dataIdFormulaireCandidature != $storeCandidature.configurationClient.DescIdFormulaireEsceInternationaleId
                        && ($storeCandidature.dataIdFormulaireCandidature != $storeCandidature.configurationClient.DescIdFormulaireMscEsce))">
                    <v-autocomplete class="pt-0" :items="listeSpecialitsEtude"
                                    v-model="$storeCandidature.sasCandidature.Identification.SpecialiteEtudes"
                                    :label="$storeCandidature.langueFormulaire == 'en' ? 'Current speciality of studies' : 'Spécialité d\'études'"
                                    :item-text="$storeCandidature.langueFormulaire == 'en' ? 'Lang01' : 'Lang00'"
                                    item-value="Id"
                                    :rules="[$rules.required($storeCandidature.langueFormulaire)]"
                                    return-object
                                    @change="specialiteChanged()"
                                    chips
                                    deletable-chips>
                    </v-autocomplete>
                </v-flex>
            </v-layout>
            <v-layout v-if="$storeCandidature.sasCandidature.Ecole
                      &&  ($storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleSupCareer)">
                <v-flex xs4>
                    <v-autocomplete class="pt-0"
                                    :items="$storeCandidature.configurationClient.SituationActuelleIdentificationList"
                                    v-model="$storeCandidature.sasCandidature.Identification.SituationActuelle"
                                    :label="$storeCandidature.langueFormulaire == 'en' ? 'Situation Actuelle' : 'Situation Actuelle'"
                                    :item-text="$storeCandidature.langueFormulaire == 'en' ? 'Lang01' : 'Lang00'"
                                    item-value="Id"
                                    @change="situationActuelle()"
                                    return-object
                                    chips
                                    deletable-chips>
                    </v-autocomplete>
                </v-flex>
                <v-flex xs4 v-if="$storeCandidature.sasCandidature.Identification.SituationActuelle
                        && $storeCandidature.sasCandidature.Identification.SituationActuelle.Id == $storeCandidature.configurationClient.DataIdStatutAlternance">
                    <v-autocomplete class="pt-0"
                                    :items="$storeCandidature.configurationClient.TypeContratList"
                                    v-model="$storeCandidature.sasCandidature.Identification.TypeDeContrat"
                                    :label="$storeCandidature.langueFormulaire == 'en' ? 'Type de contrat' : 'Type de Contrat'"
                                    :item-text="$storeCandidature.langueFormulaire == 'en' ? 'Lang01' : 'Lang00'"
                                    item-value="Id"
                                    @change="$storeCandidature.candidatureChanged = true"
                                    return-object
                                    chips
                                    deletable-chips>
                    </v-autocomplete>
                </v-flex>
                <v-flex xs4 v-if=" ($storeCandidature.sasCandidature.Ecole
                        || $storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleSupCareer)
                         && $storeCandidature.sasCandidature.Identification.SituationActuelle
                        && $storeCandidature.sasCandidature.Identification.SituationActuelle.Id == $storeCandidature.configurationClient.DataIdStatutSalarie ">
                    <v-text-field :counter="30"
                                  v-model="$storeCandidature.sasCandidature.Identification.Employeur"
                                  :label="$storeCandidature.langueFormulaire == 'en' ? 'Employeur' : 'Employeur'"
                                  @change="$storeCandidature.candidatureChanged = true">
                    </v-text-field>
                </v-flex>
                <v-flex xs4 v-if=" ($storeCandidature.sasCandidature.Ecole
                        || $storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleSupCareer)
                        && $storeCandidature.sasCandidature.Identification.SituationActuelle
                        && $storeCandidature.sasCandidature.Identification.SituationActuelle.Id == $storeCandidature.configurationClient.DataIdStatutSalarie">
                    <v-text-field :counter="30"
                                  v-model="$storeCandidature.sasCandidature.Identification.AnneeEntreeEmployeur"
                                  :label="$storeCandidature.langueFormulaire == 'en' ? 'Employeur' : 'Annee Entree Employeur'"
                                  @change="$storeCandidature.candidatureChanged = true">
                    </v-text-field>
                </v-flex>
            </v-layout>
            <v-layout v-if="$storeCandidature.sasCandidature.Ecole
                                  &&  ($storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleSupDigital
                        || $storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleIdCeds)">
                <v-flex xs4>
                    <v-autocomplete class="pt-0" :items="$storeCandidature.configurationClient.AnneeObtentionList"
                                    v-model="$storeCandidature.sasCandidature.InformationsComplementaires.AnneeObtention"
                                    :label="$storeCandidature.langueFormulaire == 'en' ? 'Year of graduation' : 'Année d\'obtention du bac'"
                                    :item-text="$storeCandidature.langueFormulaire == 'en' ? 'Lang01' : 'Lang00'"
                                    item-value="Id"
                                    return-object
                                    chips
                                    deletable-chips
                                    @change="$storeCandidature.candidatureChanged = true">
                    </v-autocomplete>
                </v-flex>
                <v-flex :class="{xs8 : !$storeCandidature.sasCandidature.ParcoursScolaireTerminale.EtablissementTerminale}"
                        v-if="!$storeCandidature.sasCandidature.ParcoursScolaireTerminale.EtablissementAutre">
                    <v-autocomplete class="pt-1" :items="$storeCandidature.etablissementFrequenteTerminaleList"
                                    v-model="$storeCandidature.sasCandidature.ParcoursScolaireTerminale.EtablissementTerminale"
                                    :label="$storeCandidature.langueFormulaire == 'en' ? 'Institution name' : 'Etablissement fréquenté'"
                                    item-text="Label"
                                    item-value="Id"
                                    :search-input.sync="search"
                                    :placeholder="$storeCandidature.langueFormulaire == 'en' ? 'Enter the name of the institution.' : 'Saisissez le nom de l\'établissement.'"
                                    @keyup="debounceInputTerminal"
                                    :loading="isLoading"
                                    return-object
                                    chips
                                    deletable-chips
                                    @change="$storeCandidature.candidatureChanged = true">
                        <template #no-data>
                            <div v-if="search == null || search == ''" class="pt-2 pb-2 pl-2">{{$storeCandidature.langueFormulaire == 'en' ? 'Enter the name of the institution.' : 'Saisissez le nom de l\'établissement.'}}</div>
                            <div v-else class="pt-2 pb-2 pl-2">{{$storeCandidature.langueFormulaire == 'en' ? 'No results found' : 'Aucun établissment trouvé'}}</div>
                        </template>
                    </v-autocomplete>
                </v-flex>
            </v-layout>
            <v-layout v-if="$storeCandidature.sasCandidature.Ecole
                                  &&  ($storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleSupCareer
                      || $storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleInseecMscMba
                      || $storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleHeip )">
                <v-flex xs4 v-if="$storeCandidature.sasCandidature.Ecole
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInseecMscMba">
                    <v-autocomplete class="pt-0" :items="$storeCandidature.configurationClient.AnneeScolaireList"
                                    v-model="$storeCandidature.sasCandidature.ParcoursScolaireTerminale.AnneeTerminale"
                                    :label="$storeCandidature.langueFormulaire == 'en' ? 'Year of graduation' : 'Année d\'obtention du bac'"
                                    :item-text="$storeCandidature.langueFormulaire == 'en' ? 'Lang01' : 'Lang00'"
                                    item-value="Id"
                                    return-object
                                    chips
                                    deletable-chips
                                    @change="$storeCandidature.candidatureChanged = true">
                    </v-autocomplete>
                </v-flex>
                <v-flex v-if="!$storeCandidature.sasCandidature.ParcoursScolaireTerminale.EtablissementAutre">
                    <v-autocomplete class="pt-1" :items="$storeCandidature.etablissementFrequenteTerminaleList"
                                    v-model="$storeCandidature.sasCandidature.ParcoursScolaireTerminale.EtablissementTerminale"
                                    :label="$storeCandidature.langueFormulaire == 'en' ? 'Institution name' : 'Etablissement fréquenté'"
                                    item-text="Label"
                                    item-value="Id"
                                    :search-input.sync="search"
                                    :placeholder="$storeCandidature.langueFormulaire == 'en' ? 'Enter the name of the institution.' : 'Saisissez le nom de l\'établissement.'"
                                    @change="$storeCandidature.candidatureChanged = true"
                                    @keyup="debounceInputTerminal"
                                    :loading="isLoading"
                                    return-object
                                    chips
                                    deletable-chips>
                        <template #no-data>
                            <div v-if="search == null || search == ''" class="pt-2 pb-2 pl-2">{{$storeCandidature.langueFormulaire == 'en' ? 'Enter the name of the institution.' : 'Saisissez le nom de l\'établissement.'}}</div>
                            <div v-else class="pt-2 pb-2 pl-2">{{$storeCandidature.langueFormulaire == 'en' ? 'No results found' : 'Aucun établissment trouvé'}}</div>
                        </template>
                    </v-autocomplete>
                </v-flex>

                <v-flex v-if="!$storeCandidature.sasCandidature.ParcoursScolaireTerminale.EtablissementTerminale">
                    <v-text-field v-model="$storeCandidature.sasCandidature.ParcoursScolaireTerminale.EtablissementAutre"
                                  @change="$storeCandidature.candidatureChanged = true"
                                  :label="$storeCandidature.langueFormulaire == 'en' ? 'Institution name (If not in the list)' : 'Etablissement (Si pas dans la liste)'">
                    </v-text-field>
                </v-flex>
            </v-layout>
            <v-layout row wrap xs12 v-if="$storeCandidature.sasCandidature.Ecole
                          &&  ($storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleInseecBachelors
                      || $storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.IdInseecBachelors
                      || $storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdBtsInseec
                          || $storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleEce)">
                <v-flex v-if="!$storeCandidature.sasCandidature.ParcoursScolaireSuperieur.EtablissementAutre"
                        :class="{xs6 : !$storeCandidature.sasCandidature.ParcoursScolaireSuperieur.EtablissementPostBac}">
                    <v-autocomplete class="pt-1" :items="$storeCandidature.etablissementFrequentePostBacList"
                                    @change="$storeCandidature.candidatureChanged = true"
                                    v-model="$storeCandidature.sasCandidature.ParcoursScolaireSuperieur.EtablissementPostBac"
                                    :label="$storeCandidature.langueFormulaire == 'en' ? 'Institution name' : 'Etablissement fréquenté'"
                                    :placeholder="$storeCandidature.langueFormulaire == 'en' ? 'Enter the name of the institution.' : 'Saisissez le nom de l\'établissement.'"
                                    item-text="Label"
                                    item-value="Id"
                                    :search-input.sync="search"
                                    @keyup="debounceInputPostBac"
                                    :loading="isLoading"
                                    return-object
                                    chips
                                    deletable-chips>
                        <template #no-data>
                            <div v-if="search == null || search == ''" class="pt-2 pb-2 pl-2">{{$storeCandidature.langueFormulaire == 'en' ? 'Enter the name of the institution.' : 'Saisissez le nom de l\'établissement.'}}</div>
                            <div v-else class="pt-2 pb-2 pl-2">{{$storeCandidature.langueFormulaire == 'en' ? 'No results found' : 'Aucun établissment trouvé'}}</div>
                        </template>
                    </v-autocomplete>
                </v-flex>
                <v-flex :class="{xs6 : !$storeCandidature.sasCandidature.ParcoursScolaireSuperieur.EtablissementAutre}"
                        v-if="!$storeCandidature.sasCandidature.ParcoursScolaireSuperieur.EtablissementPostBac">
                    <v-text-field v-model="$storeCandidature.sasCandidature.ParcoursScolaireSuperieur.EtablissementAutre"
                                  :label="$storeCandidature.langueFormulaire == 'en' ? 'Institution name (If not in the list)' : 'Etablissement (Si pas dans la liste)'"
                                  @change="$storeCandidature.candidatureChanged = true">
                    </v-text-field>
                </v-flex>
            </v-layout>
            <v-layout row wrap xs12>
                <v-flex xs4 v-if="$storeCandidature.dataIdFormulaireCandidature == $storeCandidature.configurationClient.DescIdFormulaireDBA
                || $storeCandidature.dataIdFormulaireCandidature == $storeCandidature.configurationClient.DescIdFormulairePHD">
                    <v-autocomplete class="pt-0" :items="$storeCandidature.configurationClient.TypeLangueList"
                                    :label="$storeCandidature.langueFormulaire == 'en' ? 'English Proficiency Level': 'Niveau d\'anglais'"
                                    :item-text="$storeCandidature.langueFormulaire == 'en' ? 'Lang01' : 'Lang00'"
                                    :rules="[$rules.required($storeCandidature.langueFormulaire)]"
                                    v-model="$storeCandidature.sasCandidature.NiveauAnglais"
                                    @change="niveauAnglaisChange()"
                                    item-value="Id"
                                    return-object
                                    chips
                                    deletable-chips>
                    </v-autocomplete>
                </v-flex>
                <v-flex xs4 v-if="$storeCandidature.sasCandidature.Identification.NiveauEtudes && $storeCandidature.sasCandidature.Ecole
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInseecBachelors
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdBtsInseec
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInseecBba
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIum
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInternational
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInseecMscMba">
                    <v-text-field :counter="100"
                                  v-model="$storeCandidature.sasCandidature.Identification.PrecisionNiveau"
                                  :label="$storeCandidature.langueFormulaire == 'en' ? 'Specify level of education' : 'Précisez niveau d\'études'"
                                  @change="$storeCandidature.candidatureChanged = true">
                    </v-text-field>
                </v-flex>
                <v-flex xs4 pl-5 v-if="$storeCandidature.sasCandidature.Ecole
                        && $storeCandidature.dataIdFormulaireCandidature != $storeCandidature.configurationClient.DescIdFormulaireEbsRentreeDecaleeId
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIdCeds
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIum
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInseecBachelors
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdBtsInseec
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInseecBba
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleSupDePub
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIdSupCreation
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInseecMscMba
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInternational
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIdDBA
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIdPHD
                        && $storeCandidature.dataIdFormulaireCandidature != $storeCandidature.configurationClient.DescIdFormulaireDBA
                        && $storeCandidature.dataIdFormulaireCandidature != $storeCandidature.configurationClient.DescIdFormulairePHD
                        && $storeCandidature.dataIdFormulaireCandidature != $storeCandidature.configurationClient.DescIdFormulaireEsceInternationaleId
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleSupCareer">
                    <v-switch :label="$storeCandidature.langueFormulaire == 'en' ? 'Scholarship' : 'Boursier'" v-model="$storeCandidature.sasCandidature.Identification.Boursier" 
                              @change="$storeCandidature.candidatureChanged = true">
                    </v-switch>
                </v-flex>
                <v-flex pl-3 v-if="$storeCandidature.sasCandidature.Ecole
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIdCeds
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIum
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIdDBA
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIdPHD
                        && $storeCandidature.dataIdFormulaireCandidature != $storeCandidature.configurationClient.DescIdFormulaireDBA
                        && $storeCandidature.dataIdFormulaireCandidature != $storeCandidature.configurationClient.DescIdFormulairePHD
                        && $storeCandidature.dataIdFormulaireCandidature != $storeCandidature.configurationClient.DescIdFormulaireEsceInternationaleId
                        && $storeCandidature.dataIdFormulaireCandidature != $storeCandidature.configurationClient.DescIdFormulaireEbsId">
                    <v-switch :label="$storeCandidature.langueFormulaire == 'en' ? 'I would like to benefit from special arrangements (time off, accessibility, special equipment, etc.)' : 'Je souhaite bénéficier d\'un aménagement particulier (tiers temps, accessibilité, matériel spécifique, etc.)'"
                              v-model="$storeCandidature.sasCandidature.Identification.BenificieTierTemps" 
                              @change="$storeCandidature.candidatureChanged = true">
                    </v-switch>
                </v-flex>
            </v-layout>
            <v-flex xs4 v-if="$storeCandidature.dataIdFormulaireCandidature == $storeCandidature.configurationClient.DescIdFormulaireDBA">
                <v-autocomplete class="pt-1" :menu-props="{maxHeight:'40%'}"
                                :label="$storeCandidature.langueFormulaire == 'en' ? 'Years of professional experience' : 'Nombre d\'années d\'expérience professionnelle'"
                                :items="$storeCandidature.configurationClient.AnneesExperienceProList"
                                v-model="$storeCandidature.sasCandidature.SituationActuelle.AnneesDExperiencePro"
                                :item-text="$storeCandidature.langueFormulaire == 'en' ? 'Lang01' : 'Lang00'"
                                item-value="Id"
                                return-object
                                @change="$storeCandidature.candidatureChanged = true" />
            </v-flex>
            <v-layout row wrap xs12>
                <v-flex xs4 pl-3 v-if="$storeCandidature.sasCandidature.Ecole
                        && $storeCandidature.dataIdFormulaireCandidature != $storeCandidature.configurationClient.DescIdFormulaireEbsRentreeDecaleeId
                        && $storeCandidature.dataIdFormulaireCandidature != $storeCandidature.configurationClient.DescIdFormulaireSupCareerCoursSoirId
                        && $storeCandidature.dataIdFormulaireCandidature != $storeCandidature.configurationClient.DescIdFormulaireSupCareerVaeId
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInseecBachelors
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdBtsInseec
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInternational
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInseecBba
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIdDBA
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIdPHD
                        && $storeCandidature.dataIdFormulaireCandidature != $storeCandidature.configurationClient.DescIdFormulaireDBA
                        && $storeCandidature.dataIdFormulaireCandidature != $storeCandidature.configurationClient.DescIdFormulairePHD
                        && $storeCandidature.dataIdFormulaireCandidature != $storeCandidature.configurationClient.DescIdFormulaireEsceInternationaleId
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIum">
                    <v-switch :label="$storeCandidature.langueFormulaire == 'en' ? 'Already a group OMNES Education' : 'Déjà étudiant groupe OMNES Education'"
                              v-model="$storeCandidature.sasCandidature.Identification.DejaEtudiantEcole"
                              @change="$storeCandidature.candidatureChanged = true">
                    </v-switch>
                </v-flex>
                <v-flex xs4 pl-3 v-if="!$storeCandidature.configurationClient.Loaded || ($storeCandidature.dataIdFormulaireCandidature == $storeCandidature.configurationClient.DescIdFormulaireSupCareerId)">
                    <v-switch :label="$storeCandidature.langueFormulaire == 'en' ? '' : 'Je certifie avoir lu les conditions de l’alternance'"
                              :rules="[$rules.required($storeCandidature.langueFormulaire)]"
                              v-model="$storeCandidature.sasCandidature.Identification.ConditionsAlternanceOK"
                              @change="$storeCandidature.candidatureChanged = true">
                    </v-switch>
                </v-flex>
                <v-flex xs4>
                    <v-autocomplete class="pt-0" :items="$storeCandidature.configurationClient.EcoleList"
                                    v-if="$storeCandidature.sasCandidature.Identification.DejaEtudiantEcole"
                                    v-model="$storeCandidature.sasCandidature.Identification.Ecole"
                                    :label="$storeCandidature.langueFormulaire == 'en' ? 'School' : 'Ecole'"
                                    :item-text="$storeCandidature.langueFormulaire == 'en' ? 'Lang01' : 'Lang00'"
                                    item-value="Id"
                                    return-object
                                    chips
                                    deletable-chips
                                    @change="$storeCandidature.candidatureChanged = true">
                    </v-autocomplete>
                </v-flex>
                <v-flex xs4>
                    <v-text-field v-if="$storeCandidature.sasCandidature.Identification.DejaEtudiantEcole
                                  &&  ($storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleHeip
                                  && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIdCeds
                                  && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInternational
                                    && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleSupDigital
                                  && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIdSupCreation
                                  && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInseecMscMba
                                    && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleSupDePub)"
                                  :counter="10"
                                  v-model="$storeCandidature.sasCandidature.Identification.NumEtudiant"
                                  :label="$storeCandidature.langueFormulaire == 'en' ? 'Student number' : 'N° Etudiant'"
                                  @change="$storeCandidature.candidatureChanged = true">
                    </v-text-field>
                </v-flex>
            </v-layout>
            <v-layout v-if="$storeCandidature.sasCandidature.Ecole
                      &&  ($storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleIdPHD
                      || $storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleIdDBA )">
                <v-flex v-if="$storeCandidature.sasCandidature.Ecole && $storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleIdPHD">
                    <v-switch :label="$storeCandidature.langueFormulaire == 'en' ? 'Did you Complete your Master degree' : 'Did you Complete your Master degree'"
                              v-model="$storeCandidature.sasCandidature.SituationActuelle.MasterObtenu"
                              @change="$storeCandidature.candidatureChanged = true">
                    </v-switch>
                </v-flex>
            </v-layout>
            <v-layout row wrap xs12>
                <Comp_Concentement v-if="etape == 1"></Comp_Concentement>
            </v-layout>
            <WarningDialog v-model="dialogSituation" v-bind:titre="titre" v-bind:message="message" />
        </v-container>
        <WarningDialog v-model="dialogNiveauAnglais" v-bind:titre="titreNiveauLangue" v-bind:message="messageLangue" />
    </v-form>
</template>
<script>
    import Comp_Identite from "../components/CompIdentite"
    import Comp_Email from "../components/CompEmail"
    import Comp_Telephone from "../components/CompTelephone"
    import Comp_Concentement from "../components/CompConsentement"
    import WarningDialog from './dialog/DialogWarningUtilisateur.vue'
    import lodash from 'lodash';
    import { TIMEOUT_ETABLISSEMENT } from '../constants'

    export default {
        props: {
            etape: {
                required: true,
                default: 1
            }
        },

        components: {
            Comp_Identite,
            Comp_Email,
            Comp_Telephone,
            Comp_Concentement,
            WarningDialog
        },

        data() {
            return {
                // Réaffecter l'objet global pour forcer la maj en temps réel
                $storeCandidature: this.$storeCandidature,
                dialogSituation: false,
                titre: 'Alerte',
                message: 'Situation actuelle non autorisée pour la formation VAE. Vous pouvez toutefois finaliser votre dossier, le service admission vous contactera pour réorienter votre demande.',
                listeSpecialitsEtudeFiltree: [],
                dialogNiveauAnglais: false,
                titreNiveauLangue: 'Warning',
                messageLangue: '',
                messageAnglais: 'We are sorry but your level of English is insufficient to integrate this training',
                messageFrancais: "Nous sommes navrés mais votre niveau d'anglais est insuffisant pour intégrer cette formation.",
                search: '',
                isLoading: false,
            }
        },

        computed: {
            // Liste niveau d'étude filtré
            listeTypesEtude() {
                if (this.$storeCandidature.sasCandidature.Identification.NiveauEtudes) {
                    return this.$storeCandidature.configurationClient.ParamFormulaire.TypesEtudes.filter(fileData => fileData.Parent != null && fileData.Parent.Id == this.$storeCandidature.sasCandidature.Identification.NiveauEtudes.Id)
                }
                else {
                    return []
                }
            },

            // Liste niveai d'étude filtré
            listeSpecialitsEtude() {
                if (this.$storeCandidature.sasCandidature.Identification && this.$storeCandidature.sasCandidature.Identification.TypeEtudes) {
                    return this.$storeCandidature.configurationClient.ParamFormulaire.SpecialitesEtudes.filter(fileData => fileData.Parent != null && fileData.Parent.Id == this.$storeCandidature.sasCandidature.Identification.TypeEtudes.Id)
                }
                else {
                    return []
                }
            },
        },

        methods: {

            // Recherche des etablissements.
            debounceInputTerminal: lodash.debounce(async function () {

                // Afficher le chargement.
                this.isLoading = true

                if (this.$storeCandidature) {

                    await this.$storeCandidature.chargerListesEtablissementFrequenteTerminal(this.search);

                    // Ne plus afficher.
                    this.isLoading = false
                }
            }, TIMEOUT_ETABLISSEMENT),

            // Recherche des etablissements PostBac.
            debounceInputPostBac: lodash.debounce(async function () {

                // Afficher le chargement.
                this.isLoading = true

                if (this.$storeCandidature) {

                    await this.$storeCandidature.chargerListesEtablissementFrequentePostBacList(this.search);

                    // Ne plus afficher.
                    this.isLoading = false
                }
            }, TIMEOUT_ETABLISSEMENT),


            // Initialiser Spécialités: Au changement de la valeur du niveau d'Etude
            niveauEtudeChanged() {

                this.$storeCandidature.sasCandidature.Identification.TypeEtudes = null
                this.$storeCandidature.sasCandidature.Identification.SpecialiteEtudes = null
                this.listeSpecialitsEtudeFiltree = []
                this.$storeCandidature.candidatureChanged = true
            },

            ValidateForm() {
                this.$refs.etapeIdentification.validate();
            },

            // Initialiser Spécialités: Au changement de la valeur de type d'Etude
            typeEtudesChanged() {

                this.$storeCandidature.sasCandidature.Identification.SpecialiteEtudes = null
                this.$storeCandidature.candidatureChanged = true
            },

            niveauAnglaisChange() {
                this.$storeCandidature.candidatureChanged = true;

                // vérification de si le niveau est suffisant
                if (this.$storeCandidature.sasCandidature.NiveauAnglais
                    && this.$storeCandidature.configurationClient
                    && this.$storeCandidature.sasCandidature.NiveauAnglais.Id == this.$storeCandidature.configurationClient.DataIdDebutant) {

                    if (this.$storeCandidature.langueFormulaire == 'en') {
                        this.messageLangue = this.messageAnglais;
                    } else {
                        this.messageLangue = this.messageFrancais;
                    }

                    this.$storeCandidature.sasCandidature.NiveauAnglais = Object.assign({}, null);
                    // affichage du message
                    this.dialogNiveauAnglais = true;
                }
            },

            // Cargement de Spécialité d'étude
            specialiteChanged() {
                if (this.$storeCandidature.sasCandidature.Ecole
                    && this.$storeCandidature.sasCandidature.Ecole.Id == this.$storeCandidature.configurationClient.DataIdEcoleEce) {
                    this.$storeCandidature.chargerProgrammes(this.$storeCandidature.sasCandidature.Ecole.Id, true);
                }
                this.$storeCandidature.candidatureChanged = true;
            },

            // Methode de validation de la situation, pour le formulaire VAE si la valuer est 'Etudiant alternance ou Etudiant initiale
            // on enlève la valeur puis on demande à l'utilisateur de saisir une valeur valide.
            situationActuelle() {
                this.$storeCandidature.candidatureChanged = true;
                // Si on est sur le formulaire VAE
                if (this.$storeCandidature.dataIdFormulaireCandidature == this.$storeCandidature.configurationClient.DescIdFormulaireSupCareerVaeId) {
                    //
                    if (this.$storeCandidature.sasCandidature.Identification.SituationActuelle &&
                        (this.$storeCandidature.sasCandidature.Identification.SituationActuelle.Id == this.$storeCandidature.configurationClient.DataIdSituationActuelleEtudiantAlternance ||
                            this.$storeCandidature.sasCandidature.Identification.SituationActuelle.Id == this.$storeCandidature.configurationClient.DataIdSituationActuelleEtudiantInitial)) {

                        this.$storeCandidature.sasCandidature.Identification.SituationActuelle = null;
                        this.dialogSituation = true;
                    }
                }
            },

            // Vérifie si au moin une des nationnalité du candidate est europeen.
            verificationNationalite() {

                // Si la liste des nationalite n'est pas vide.
                if (this.$storeCandidature.sasCandidature.Identification
                    && this.$storeCandidature.sasCandidature.Identification.Nationalite) {

                    // Si la nationalité est européenne.
                    if (this.$storeCandidature.sasCandidature.Identification.Nationalite.Code == "E") {
                        return true;
                    }

                    // Sinon false.
                    return false;
                }
                return true;
            },

            // Satze naissance modifié avec sélection calendrié
            dateSelected() {
                this.$storeCandidature.sasCandidature.Identification.DateNissanceSaisie = this.$moment(String(this.$storeCandidature.sasCandidature.Identification.DateNaissance)).format('DD/MM/YYYY')
                this.$storeCandidature.candidatureChanged = true
            },

            // Date naissance modifié manuellement
            dateSaisieChange() {
                if (this.$moment(this.$storeCandidature.sasCandidature.Identification.DateNissanceSaisie, "DD/MM/YYYY", true).isValid()) {
                    var momentDate = this.$moment(this.$storeCandidature.sasCandidature.Identification.DateNissanceSaisie, "DD/MM/YYYY")
                    this.$storeCandidature.sasCandidature.Identification.DateNaissance = momentDate.toDate()
                    this.$storeCandidature.candidatureChanged = true
                }
            },

            // Vérifier la validité de date saisie
            dateSaisieValidate() {
                if (!this.$moment(this.$storeCandidature.sasCandidature.Identification.DateNissanceSaisie, "DD/MM/YYYY", true).isValid()) {
                    this.$storeCandidature.sasCandidature.Identification.DateNaissance = ''
                    this.$storeCandidature.sasCandidature.Identification.DateNissanceSaisie = null
                    this.$storeCandidature.candidatureChanged = true
                }
            },

            // Push le EtablissementTerminale à la liste pour ne pas que l'utilisateur voit une valeur vide.
            pushEtablissementTerminale() {

                if (this.$storeCandidature.sasCandidature.ParcoursScolaireTerminale
                    && this.$storeCandidature.sasCandidature.ParcoursScolaireTerminale.EtablissementTerminale) {

                    this.$storeCandidature.etablissementFrequenteTerminaleList.push({ ...this.$storeCandidature.sasCandidature.ParcoursScolaireTerminale.EtablissementTerminale })
                }

                // Kill du watcher  quand la valeur a pu être récupéré une fois ou que la candidature n'a pas d'identifient.
                if (this.$storeCandidature.sasCandidature.ParcoursScolaireTerminale.EtablissementTerminale
                    || !this.$storeCandidature.sasCandidature.IdCrypte) {
                    this.etablissementWatcherTerminal();
                }
            },

            // Push le EtablissementPostBack à la liste pour ne pas que l'utilisateur voit une valeur vide.
            pushEtablissementPostBac() {
                if (this.$storeCandidature.sasCandidature.ParcoursScolaireSuperieur
                    && this.$storeCandidature.sasCandidature.ParcoursScolaireSuperieur.EtablissementPostBac) {

                    this.$storeCandidature.etablissementFrequentePostBacList.push({ ...this.$storeCandidature.sasCandidature.ParcoursScolaireSuperieur.EtablissementPostBac })
                }

                // Kill du watcher quand la valeur a pu être récupéré une fois ou que la candidature n'a pas d'identifient.
                if (this.$storeCandidature.sasCandidature.ParcoursScolaireSuperieur.EtablissementPostBac
                    || !this.$storeCandidature.sasCandidature.IdCrypte) {
                    this.etablissementWatcherPostBac();
                }
            }
        },

        mounted() {
            if (this.$refs.etapeIdentification) {
                this.$refs.etapeIdentification.validate()
            }

            // Mise en place de watchers provisoires.
            this.etablissementWatcherTerminal = this.$watch('$storeCandidature.sasCandidature.ParcoursScolaireTerminale', () => {
                this.pushEtablissementTerminale();
            });

            this.etablissementWatcherPostBac = this.$watch('$storeCandidature.sasCandidature.ParcoursScolaireSuperieur.EtablissementPostBac', () => {
                this.pushEtablissementPostBac();
            });
        },
    }
</script>
